module.exports = __webpack_public_path__ + "static/media/swasthik_jung.552852ba.jpg";